import React from "react";
import Footer from "./component/landingpage/footer/Footer";
import TopNav from "./component/landingpage/header/TopNav";
import ServiceBilling from "./component/landingpage/servicebilling/ServiceBilling";

const Services = () => {
  return (
    <>
      <TopNav />

      <ServiceBilling />

      <Footer />
    </>
  );
};

export default Services;
